import React, { useState, useEffect } from 'react'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'

const ModalCase3 = ({
  amenitiesDefinitions,
  isOpen,
  master = '',
  childs = [],
  onSubmit,
  onUndo,
  dictionary,
}) => {
  // const { dictionary } = window.bookingData || window.modifyData
  const [records, setRecords] = useState([])

  useEffect(() => {
    setRecords(amenitiesDefinitions)
  }, [])

  const masterTitle = () => {
    return master ? records.find((i) => i.code === master)?.name || '' : ''
  }

  const childsTitles = () => {
    return records.filter((i) => childs.includes(i.code)).map((i) => i.name)
  }

  const text = () => {
    const value = `<strong>${masterTitle()}</strong>`
    return dictionary.modalCase3Text.replace('{0}', value)
  }

  const handleUndo = () => {
    onUndo(master)
  }

  const handleSubmit = () => {
    onSubmit(master, childs)
  }

  return (
    <div
      id="modalCase3"
      className={`modal s-modal s-modal--warning  ${
        isOpen ? 'show d-block' : ''
      }`}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              <div>
                <i className="icon-warning"></i>
              </div>
              <div>{dictionary.modalCase3Title}</div>
            </div>
          </div>
          <div className="modal-body">
            <div>
              <SanitizeHtml tag="p" html={text()} />
            </div>
            <ul className="b-extras-as-badges-list">
              {childsTitles().map((child, index) => (
                <li key={index}>
                  <div className="e-extra-as-badge">{child}</div>
                </li>
              ))}
            </ul>
          </div>
          <div className="modal-footer">
            <ul>
              <li>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={handleUndo}
                  title={dictionary.modalCase3ButtonUndoText}>
                  {dictionary.modalCase3ButtonUndoText}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  title={dictionary.modalCase3ButtonSubmitText}>
                  {dictionary.modalCase3ButtonSubmitText}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCase3
